import { slugifyKey } from "@/shared/lib/slug";

export function slugifyWorkObjectFieldKey(value: string) {
  return slugifyKey(value, "");
}
